import reducerRegistry from '../../reducers/ReducerRegistry';
import { routerHistoryReducer } from './reducers';

export { setHistory } from './actions';
export { historySelector } from './selectors';

reducerRegistry.register({
    routerHistory: routerHistoryReducer,
});
